import {Injectable} from "@angular/core";
import {LOCALIZATIONS} from "./localizations";
import {LocalizationStrings} from "./i18n-model";

@Injectable()
export class LocalizationsProvider {

  getLocalizations(): Map<string, LocalizationStrings> {
    return LOCALIZATIONS;
  }
}
